 type Replacer = (key: string, value: unknown) => unknown
export function download(data: object, filename: string, replacer?: Replacer) {
    const blob = new Blob([JSON.stringify(data, replacer, 2)], {type: "application/json"})
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
}